export default __webpack_public_path__ + "static/media/674.41130dd9.png";